import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getBackgroundOpacityMenuItems } from './lib'

/**
 * Settings subtitles background opacity menu
 */
export const SettingsSubtitlesBackgroundOpacityMenu = createSubtitlesCustomMenu(
  'SettingsSubtitlesBackgroundOpacityMenu',
  'background_opacity',
  getBackgroundOpacityMenuItems
)
